<template>
    <v-app id="forget_password" class="primary general-form-wrapper">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <v-form id="reset_password_form" method="post" :action="form.action" v-on:success="request_success" ref="forget_password_form">
                            <v-card class="elevation-1 pa-3">

                                <v-card-text>
                                    <template v-if="!form.request_success">
                                        <div class="layout column align-center">
                                            <h1 class="flex my-4 primary--text">{{$t('login.forget_password')}}</h1>
                                        </div>

                                        <v-alert
                                                :value="true"
                                                type="info"
                                        >
                                            {{$t('forget_password.form_description')}}
                                        </v-alert>

                                        <v-text-field
                                                append-icon="email"
                                                ref="email"
                                                name="email"
                                                :placeholder="$t('user.email')"
                                                type="text"
                                                :error-messages="errors.email"
                                        >
                                        </v-text-field>
                                    </template>

                                    <template v-else>
                                        {{$t('forget_password.msg_password_reset_email_sent')}}
                                    </template>

                                </v-card-text>

                                <v-card-actions>

                                    <template v-if="!form.request_success">
                                        <v-btn block color="primary"
                                               type="submit"
                                               ref="submit"
                                               :loading="form.loading"
                                        >{{$t('action.submit')}}</v-btn>
                                    </template>

                                    <template v-else>
                                        <v-btn block color="primary" @click="goLogin"
                                        >{{$t('forget_password.to_login_page')}}</v-btn>
                                    </template>

                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <app-footer></app-footer>
    </v-app>
</template>

<script>
    import FormHandling from '~/utils/data/form-handling';
    import {UrlServices} from "~/utils/url-manager";
    import AppFooter from "~/components/AppFooter";

    export default {
        name: "ForgetPassword",
        components: {AppFooter},
        data() {
            return {
                form: {
                    action: UrlServices.createUrl({'name': 'api_forget_password'}),
                    loading: false,
                    request_success: false
                },
                rules: {
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || this.$t('login.email_invalid')
                    }
                },
                errors: {
                    email: ""
                }
            }
        },
        methods: {
            request_success() {
                this.form.request_success = true;
            },
            goLogin() {
                this.$router.push({ name: 'public_login'});
            }
        },
        mounted: function() {
            new FormHandling(this, "forget_password_form");
        }
    }
</script>

<style scoped>

</style>